function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __markAsModule = function __markAsModule(target) {
  return __defProp(target, "__esModule", {
    value: true
  });
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var __export = function __export(target, all) {
  __markAsModule(target);

  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __reExport = function __reExport(target, module2, desc) {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    var _loop = function _loop() {
      var key = _step3.value;
      if (!__hasOwnProp.call(target, key) && key !== "default") __defProp(target, key, {
        get: function get() {
          return module2[key];
        },
        enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable
      });
    };

    for (var _iterator3 = _createForOfIteratorHelperLoose(__getOwnPropNames(module2)), _step3; !(_step3 = _iterator3()).done;) {
      _loop();
    }
  }

  return target;
};

var __toModule = function __toModule(module2) {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? {
    get: function get() {
      return module2.default;
    },
    enumerable: true
  } : {
    value: module2,
    enumerable: true
  })), module2);
};

__export(exports, {
  default: function _default() {
    return Secondary_default;
  }
});

var import_showroom_css_theme2 = __toModule(require("@carvana/showroom-css-theme"));

var import_react3 = __toModule(require("@linaria/react"));

var import_react2 = __toModule(require("react"));

var import_core = __toModule(require("@linaria/core"));

var import_react = __toModule(require("@linaria/react"));

var import_showroom_css_theme = __toModule(require("@carvana/showroom-css-theme"));

var DefaultButton = (0, import_react.styled)("button")({
  name: "DefaultButton",
  class: "d14aom7e"
});
var Button = (0, import_react2.forwardRef)(function (_a, ref) {
  var _b = _a,
      _b$size = _b.size,
      size = _b$size === void 0 ? "large" : _b$size,
      _b$testId = _b.testId,
      testId = _b$testId === void 0 ? "Button" : _b$testId,
      _b$className = _b.className,
      className = _b$className === void 0 ? "" : _b$className,
      mode = _b.mode,
      children = _b.children,
      _b$type = _b.type,
      type = _b$type === void 0 ? "button" : _b$type,
      restProps = __objRest(_b, ["size", "testId", "className", "mode", "children", "type"]);

  return import_react2.default.createElement(DefaultButton, __spreadValues({
    ref: ref,
    "data-testid": testId,
    className: (0, import_core.cx)(className, mode + "-mode", size + "-size"),
    type: type
  }, restProps), children);
});
var Button_default = Button;
var Base_default = Button_default;
var Secondary_default = (0, import_react3.styled)(Base_default)({
  name: "Secondary0",
  class: "sdqfaaq"
});